/**
 * @generated SignedSource<<4bd16e8293bf872e0eba1bf62a074847>>
 * @relayHash 0c2c77e83b47d32b3cfbbf521221dc03
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0c2c77e83b47d32b3cfbbf521221dc03

import { ConcreteRequest } from 'relay-runtime';
export type AppointmentReviewStatus = "NEEDED" | "NONE" | "REVIEWED";
export type UpdateAppointmentReviewStatusInput = {
  id: string;
  isReviewed: boolean;
};
export type useUpdateAppointmentReviewStatusMutation$variables = {
  input: UpdateAppointmentReviewStatusInput;
};
export type useUpdateAppointmentReviewStatusMutation$data = {
  readonly updateAppointmentReviewStatus: {
    readonly appointment: {
      readonly reviewStatus: AppointmentReviewStatus;
    } | null;
  };
};
export type useUpdateAppointmentReviewStatusMutation = {
  response: useUpdateAppointmentReviewStatusMutation$data;
  variables: useUpdateAppointmentReviewStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reviewStatus",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUpdateAppointmentReviewStatusMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateAppointmentReviewStatusPayload",
        "kind": "LinkedField",
        "name": "updateAppointmentReviewStatus",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Appointment",
            "kind": "LinkedField",
            "name": "appointment",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useUpdateAppointmentReviewStatusMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateAppointmentReviewStatusPayload",
        "kind": "LinkedField",
        "name": "updateAppointmentReviewStatus",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Appointment",
            "kind": "LinkedField",
            "name": "appointment",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "0c2c77e83b47d32b3cfbbf521221dc03",
    "metadata": {},
    "name": "useUpdateAppointmentReviewStatusMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "95bae63cf185462c7dd82d1dc52e1968";

export default node;
